import React, { useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { IWbISafeResponse } from '@interco/inter-webview-bridge'
import { ApplicationState } from '@store/types'
import { ColorWrapper, TextParagraph, Separator } from '@atoms'
import { Button } from '@interco/inter-ui/components/Button'
import { ISafeBottomSheet } from '@interco/inter-ui/components/BottomSheet'
import { BridgeService } from '@services/bridge'
import { formatCurrency } from '@utils/masks'
import { finalizarProposta } from '@store/refinanciamento/documentosAssinatura/actions'
import routes from '@routes/routes'
import { postIsafeAutorizacao } from '@store/refinanciamento/validateISafe/actions'
import { Page } from '@templates'
import IcChevronRight from '@interco/icons/core/action-navigation/ic_chevron_right'
import IcContract from '@interco/icons/core/files/ic_contract'
import IcChevronUp from '@interco/icons/core/action-navigation/ic_chevron_up'
import IcChevronDown from '@interco/icons/core/action-navigation/ic_chevron_down'
import { Colors } from '@utils/Colors'
import { StepRefin } from '@utils/enums'
import { getSimulacaoRecalculo, trackingRefin } from '@store/refinanciamento/simulacao/actions'
import Tag from '@utils/Tag'
import {
  generateIdUnicoLinkRequest,
  getValidateBiometrics,
  postBiometriaDadoSave,
} from '@store/biometria/actions'
import { isIdCloudBiometric } from '@utils/functions'
import { useTrackingRefin } from '@hooks'

import { BoxCustom, LineInfo } from './styles'
import { variants } from './Variants'
import { BottomSheetError } from './Bottomsheets/BottomSheetError'
import Detalhes from './Detalhes'
import { BottomSheetRefazerBiometria } from './Bottomsheets/BottomSheetRefazerBiometria'

const Revisao = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useTrackingRefin(StepRefin.REVISAO_ASSINATURA)
  const [showDetails, setShowDetails] = useState(false)
  const [variant, setVariant] = useState(variants.autenticacaoRealizada)
  const [showBottomSheet, setShowBottomSheet] = useState(false)
  const [showBottomSheetRefazerBiometria, setShowBottomSheetRefazerBiometria] = useState(false)
  const [showISafe, setShowISafe] = useState(false)
  const { parcelaAtual, debtBalance } = useSelector(
    (state: ApplicationState) => state.refinanciamento.simulacao,
  )
  const { contratosSelecionados } = useSelector(
    (state: ApplicationState) => state.refinanciamento.contratos,
  )
  const { isApp } = useSelector((state: ApplicationState) => state.ui.navigation)
  const { contaDadosPessoais } = useSelector(
    (state: ApplicationState) => state.refinanciamento.dadosPessoais,
  )
  const { loadingBiometricsValidate } = useSelector((state: ApplicationState) => state.biometria)
  const { loadingFinalizarProposta } = useSelector(
    (state: ApplicationState) => state.refinanciamento.documentosAssinatura,
  )
  const { utmSource } = useSelector((state: ApplicationState) => state.session)
  const [recalculo, setRecalculo] = useState(false)
  const { biometricActive } = useSelector((state: ApplicationState) => state.biometria)

  let isafeResponse: IWbISafeResponse | undefined

  useEffect(() => {
    BridgeService.tac({
      name: 'revisao',
      actions: ['confirmar_contratacao'],
    })
  }, [])

  useEffect(() => {
    if (isApp) {
      Tag.enviarTagueamentoApp({
        screen: 'clt:refin:sign',
        ref_type: '',
        content_action: 'Dado carregado',
        action_id: 'Revisão do contrato',
        section: 'sign',
        sub_section: '',
        step: '',
        scenario: 'Revisão do contrato',
        ref_figma: '2',
      })
    } else {
      Tag.enviarTagueamentoWeb({
        element_action: 'page_loaded',
        element_name: 'Revisão do contrato',
        c_page: window.location.href,
        redirect_url: '',
        section_name: 'payrollloan:refin:summary',
        section: 'summary',
        sub_section: '',
        step: '',
        scenario: 'Revisão do contrato',
      })
    }
  }, [isApp])

  useEffect(() => {
    if (!isIdCloudBiometric(biometricActive)) {
      dispatch(
        getValidateBiometrics({
          callback: (isValid) => {
            if (!isValid) {
              setShowBottomSheetRefazerBiometria(true)
            } else {
              dispatch(trackingRefin(StepRefin.CONCLUSAO_ENVIO_DOCUMENTOS))
              dispatch(trackingRefin(StepRefin.CAPTURA_BIOMETRIA_SERASA_SUCESSO))
            }
          },
        }),
      )
    }
  }, [dispatch, biometricActive])

  useEffect(() => {
    if (showISafe) {
      BridgeService.tac({
        name: 'isafe_bottomsheet',
        actions: ['abrir_isafe_bottomsheet'],
      })

      if (isApp) {
        Tag.enviarTagueamentoApp({
          screen: 'clt:refin:isafe',
          ref_type: '',
          content_action: 'Page loaded',
          action_id: 'Autenticar transacao com o i-safe',
          section: 'isafe',
          sub_section: '',
          step: '',
          scenario: 'Autenticar transacao com o i-safe',
          ref_figma: '2',
        })
      }
    }
  }, [showISafe, isApp])

  useEffect(() => {
    if (utmSource === 'Recalculo') {
      dispatch(
        getSimulacaoRecalculo({
          callback: () => {
            setRecalculo(true)
          },
        }),
      )
    }
  }, [dispatch, utmSource])

  const callFinalizar = () => {
    BridgeService.tic({
      name: 'btn_confirmar_contratacao',
      action: 'confirmar_contratacao',
    })
    dispatch(
      finalizarProposta({
        callback: () => {
          dispatch(trackingRefin(StepRefin.PROPOSTA_FINALIZADA))
          if (isApp) {
            Tag.enviarTagueamentoApp({
              screen: 'clt:refin:sign',
              ref_type: 'botao',
              content_action: 'Toque',
              action_id: 'Confirmar contratação',
              section: 'sign',
              sub_section: '',
              step: '',
              scenario: 'Confirmar contratação',
              ref_figma: '2',
            })
          } else {
            Tag.enviarTagueamentoWeb({
              element_action: 'click button',
              element_name: 'Confirmar contratação',
              c_page: window.location.href,
              redirect_url: routes.SUCESSO,
              section_name: 'payrollloan:refin:summary',
              section: 'summary',
              sub_section: '',
              step: '',
              scenario: 'Confirmar contratação',
            })
          }
          navigate(routes.SUCESSO)
        },
        callbackTryAgain: () => {
          if (isApp) {
            Tag.enviarTagueamentoApp({
              screen: 'clt:refin:sign',
              ref_type: '',
              content_action: 'Toque',
              action_id: 'Tentar novamente',
              section: 'sign',
              sub_section: '',
              step: '',
              scenario: 'Tentar novamente',
              ref_figma: '2',
            })
          } else {
            Tag.enviarTagueamentoWeb({
              element_action: 'click button',
              element_name: 'Tentar novamente',
              c_page: window.location.href,
              redirect_url: '',
              section_name: 'payrollloan:refin:summary',
              section: 'summary',
              sub_section: '',
              step: '',
              scenario: 'Tentar novamente',
            })
          }
          setShowBottomSheetRefazerBiometria(true)
        },
      }),
    )
  }

  const onAuthenticateComplete = async (status: boolean) => {
    if (isApp) {
      isafeResponse = await BridgeService?.authenticateRequestISafe(
        Number(parcelaAtual.availableAmount),
      )
    }

    if (status && isafeResponse) {
      const { authenticationToken, authenticationType, authenticationValue } = isafeResponse
      dispatch(
        postIsafeAutorizacao({
          callback: () => {
            setShowISafe(false)
            dispatch(trackingRefin(StepRefin.REVISAO_ASSINATURA))
            callFinalizar()
          },
          erro: () => {
            setShowISafe(false)
            setVariant(variants.erroAutenticacao)
            setShowBottomSheet(true)
          },
          erroAutorizacao: () => {
            setShowISafe(false)
            setVariant(variants.erroAutorizacao)
            setShowBottomSheet(true)
          },
          tipoAutenticacao: `${authenticationType || ''}`,
          token: `${authenticationToken || ''}`,
          valor: `${authenticationValue || ''}`,
          conta: contaDadosPessoais ?? '',
        }),
      )
    } else {
      setShowISafe(false)
      setVariant(variants.erroAutenticacao)
      setShowBottomSheet(true)
    }
  }

  return (
    <Page
      stickyContainerFooterBottom="10px"
      positionFooter="sticky"
      titleHeader="Revisão do contrato"
      stickyFooter={
        <>
          <Separator margin="8px -24px" height="1px" />
          {showDetails ? (
            <>
              <div
                tabIndex={0}
                role="button"
                onKeyDown={() => {
                  setShowDetails(false)
                }}
                onClick={() => {
                  dispatch(trackingRefin(StepRefin.CLICK_REVISAO_OCULTAR_DETALHES))
                  setShowDetails(false)
                }}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignSelf: 'center',
                }}
              >
                <ColorWrapper fontWeight="700" color={Colors.PRIMARY500} margin="0 8px 0 0">
                  <TextParagraph variant="body-3">Exibir menos detalhes</TextParagraph>
                </ColorWrapper>
                <IcChevronDown width={24} height={24} color={Colors.PRIMARY500} />
              </div>
              <Detalhes />
            </>
          ) : (
            <div
              tabIndex={0}
              role="button"
              onKeyDown={() => {
                setShowDetails(true)
              }}
              onClick={() => {
                dispatch(trackingRefin(StepRefin.CLICK_REVISAO_EXIBIR_DETALHES))
                setShowDetails(true)
              }}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignSelf: 'center',
              }}
            >
              <ColorWrapper fontWeight="700" color={Colors.PRIMARY500} margin="0 8px 0 0">
                <TextParagraph variant="body-3">Exibir mais detalhes</TextParagraph>
              </ColorWrapper>
              <IcChevronUp width={24} height={24} color={Colors.PRIMARY500} />
            </div>
          )}
          <ColorWrapper margin="0 0 8px 0" color={Colors.GRAY500}>
            <TextParagraph variant="caption-1">
              Ao clicar em confirmar contratação, eu reconheço que li e concordo com os termos
              acima.
            </TextParagraph>
          </ColorWrapper>

          <Button
            disabled={
              loadingFinalizarProposta ||
              loadingBiometricsValidate ||
              showBottomSheetRefazerBiometria
            }
            isLoading={loadingBiometricsValidate || loadingFinalizarProposta}
            fullWidth
            onClick={() => {
              dispatch(trackingRefin(StepRefin.CLICK_REVISAO_CONFIRMAR_CONTRATACAO))
              dispatch(trackingRefin(StepRefin.REVISAO_ASSINATURA))
              isApp ? setShowISafe(true) : callFinalizar()
            }}
          >
            {loadingBiometricsValidate ? 'Validando biometria enviada...' : 'Confirmar contratação'}
          </Button>
        </>
      }
    >
      <ColorWrapper fontWeight="600" margin="0" style={{ textAlign: 'center' }}>
        <TextParagraph variant="headline-h1" margin="0" textAlign="center">
          Para finalizar, toque em Confirmar contratação
        </TextParagraph>
      </ColorWrapper>
      <ColorWrapper
        fontWeight="600"
        style={{
          width: '60%',
          textAlign: 'center',
          borderBottom: `1px solid ${Colors.GRAY300}`,
          alignSelf: 'center',
        }}
        margin="24px 0 0 0"
      >
        <TextParagraph variant="headline-h1" margin="0" textAlign="center">
          {formatCurrency(parcelaAtual?.requestedAmount)}
        </TextParagraph>
      </ColorWrapper>
      {recalculo ? (
        <TextParagraph textAlign="center" variant="caption-1" margin="8px 0 0 0">
          Valor do refinanciamento recalculado
        </TextParagraph>
      ) : (
        <TextParagraph textAlign="center" variant="caption-1" margin="8px 0 0 0">
          Valor do refinanciamento
        </TextParagraph>
      )}
      <Separator margin="24px 0" variant="small" style={{ backgroundColor: Colors.GRAY100 }} />
      <ColorWrapper fontWeight="600">
        <TextParagraph variant="headline-h3" margin="8px 0">
          Detalhes do refinanciamento
        </TextParagraph>
      </ColorWrapper>
      <LineInfo>
        <TextParagraph variant="caption-1">Saldo devedor pré-refinanciamento</TextParagraph>
        <ColorWrapper color={Colors.GRAY500} fontWeight="700" margin="0">
          <TextParagraph variant="caption-1" margin="0">
            {formatCurrency(debtBalance)}
          </TextParagraph>
        </ColorWrapper>
      </LineInfo>
      <LineInfo>
        <TextParagraph variant="caption-1">Troco liberado</TextParagraph>
        <ColorWrapper color={Colors.GRAY500} fontWeight="700" margin="0">
          <TextParagraph variant="caption-1" margin="0">
            {formatCurrency(parcelaAtual?.availableAmount)}
          </TextParagraph>
        </ColorWrapper>
      </LineInfo>
      <LineInfo>
        <TextParagraph variant="caption-1" style={{ maxWidth: '55%' }}>
          Novo valor disponível
        </TextParagraph>
        <ColorWrapper color={Colors.GRAY500} fontWeight="700" margin="0">
          <TextParagraph variant="caption-1" margin="0">
            {formatCurrency(parcelaAtual?.requestedAmount)}
          </TextParagraph>
        </ColorWrapper>
      </LineInfo>

      <Separator margin="8px 0 24px 0" height="1px" />

      <ColorWrapper color={Colors.GRAY500} fontWeight="700" margin="0 0 24px 0">
        <TextParagraph variant="body-3">Contratos selecionados</TextParagraph>
      </ColorWrapper>
      <>
        {contratosSelecionados?.map((contrato, index) => (
          <div key={`${contrato.numeroProposta}`}>
            {index !== 0 ? <Separator variant="small" margin="16px 0" /> : <></>}
            <LineInfo>
              <TextParagraph variant="caption-1">Valor da parcela:</TextParagraph>
              <TextParagraph variant="caption-1" colorWeight={500} bold>
                {formatCurrency(contrato.valorProximaParcela)}
              </TextParagraph>
            </LineInfo>
            <LineInfo style={{ marginBottom: '0px' }}>
              <TextParagraph variant="caption-1">Nº da proposta:</TextParagraph>
              <TextParagraph variant="caption-1" colorWeight={500} bold>
                {contrato.numeroProposta}
              </TextParagraph>
            </LineInfo>
          </div>
        ))}
      </>
      <BoxCustom
        onClick={() => {
          dispatch(trackingRefin(StepRefin.CLICK_REVISAO_VER_TERMOS))
          BridgeService.tic({
            name: 'btn_ver_termos',
            action: 'ver_termos',
          })
          if (isApp) {
            Tag.enviarTagueamentoApp({
              screen: 'clt:refin:sign',
              ref_type: 'botao',
              content_action: 'Toque',
              action_id: 'Termos da contratação',
              section: 'sign',
              sub_section: '',
              step: '',
              scenario: 'Termos da contratação',
              ref_figma: '2',
            })
          } else {
            Tag.enviarTagueamentoWeb({
              element_action: 'click button',
              element_name: 'Termos da contratação',
              c_page: window.location.href,
              redirect_url: routes.TERMOS_CONTRATACAO,
              section_name: 'payrollloan:refin:summary',
              section: 'summary',
              sub_section: '',
              step: '',
              scenario: 'Termos da contratação',
            })
          }
          navigate(routes.TERMOS_CONTRATACAO)
        }}
        actived={false}
      >
        <IcContract height={24} width={24} color={Colors.GRAY500} />
        <TextParagraph
          variant="body-3"
          style={{
            width: '70%',
            color: Colors.GRAY500,
            fontWeight: 700,
            alignContent: 'flex-start',
          }}
        >
          Termos da contratação
        </TextParagraph>
        <IcChevronRight height={24} width={24} color={Colors.PRIMARY500} />
      </BoxCustom>

      {showISafe ? (
        <ISafeBottomSheet
          authenticate={() => Promise.resolve()}
          onComplete={onAuthenticateComplete}
          onClose={() => setShowISafe(false)}
          description="Para sua segurança estamos autenticando sua transação com o i-safe."
        />
      ) : (
        <></>
      )}
      {showBottomSheet ? (
        <BottomSheetError setShowBottomSheet={setShowBottomSheet} variant={variant} />
      ) : (
        <></>
      )}
      {showBottomSheetRefazerBiometria ? (
        <BottomSheetRefazerBiometria
          setShowBottomSheetRefazerBiometria={setShowBottomSheetRefazerBiometria}
          redirectBiometria={() => {
            dispatch(trackingRefin(StepRefin.CLICK_REVISAO_REFAZER_BIOMETRIA))
            dispatch(
              postBiometriaDadoSave({
                callback: () => {
                  dispatch(trackingRefin(StepRefin.ORIENTACOES_VIDEO_SELFIE))

                  if (isIdCloudBiometric(biometricActive)) {
                    dispatch(
                      generateIdUnicoLinkRequest({
                        callback: (biometricLink: string) => {
                          window.location.href = biometricLink
                        },
                      }),
                    )
                    return
                  }

                  navigate(routes.BIOMETRIA_LIVENESS)
                },
              }),
            )
          }}
        />
      ) : (
        <></>
      )}
    </Page>
  )
}
export default Revisao
